<div class="adhoc-report-template-container">
  <h3>Manage Template</h3>
  <div class="adhoc-report-template-config">
    <div class="grid-wrap"> 
      <ptg-grid
        [data]="listTemplates"
        [columns]="columns"
        [paginable]="false"
        [hideHeader]="true"
        notFoundMessage="No Data to Display"
      >
        <ng-template cellContent [columnName]="'columnName'" let-row>
          <div class="multiple-line-text">
            <p class="caption">{{ row.name }}</p>
            <p class="description">{{ row.valueDescription }}</p>
          </div>
        </ng-template>

        <ng-template cellContent [columnName]="ACTION_COLUMN" let-row>
          <ng-container>
            <ptg-button buttonName="" class="inline-block h-fit" classInput="delete-button !top-0" (clickButton)="onUpdateTemplate(row)">
                <mat-icon class="!relative">edit</mat-icon>
            </ptg-button>
            <ptg-button buttonName="" class="inline-block h-fit" classInput="delete-button !top-0 non-action" (clickButton)="onRemoveTemplate(row)">
              <mat-icon class="!relative">delete_forever</mat-icon>
            </ptg-button>
          </ng-container>
        </ng-template>
      </ptg-grid>
    </div>
    <div id="loading-table" *ngIf="isLoading">
      <div class="wrap-item">
          <mat-progress-spinner diameter="50" mode="indeterminate">
          </mat-progress-spinner>
          <p>Loading...</p>
      </div>
    </div>
  </div>

  <div class="button-control">
    <button
    mat-raised-button
    type="button"
    class="cancel-button"
    (click)="onCancel()"
    >
      Close
    </button>
  </div>

</div>
